import { ApiParameters } from "./api-parameters";
import { ApiPutRequest } from "./api-put-request";

export class SustainOrderRequest extends ApiPutRequest
{
    public constructor(orderId: number, webapiBasepath:string)
    {
        const parameters = new ApiParameters().addQueryParameter('id', orderId);
        super('ordersustain', parameters, null, null, webapiBasepath);
    }
}
